import * as styles from "./FieldLabel.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Field as BaseField } from "@base-ui/react/field";

import { useFieldContext } from "./Field.context";
import type { FieldLabelProps } from "./Field.types";

export function FieldLabel({
  className,
  ...props
}: FieldLabelProps): JSX.Element {
  const { orientation, size, labelAlign, labelBlockAlign } = useFieldContext();

  return (
    <BaseField.Label
      data-slot="field-label"
      className={clsx(
        styles.label({ orientation, size, labelAlign, labelBlockAlign }),
        className,
      )}
      {...props}
    />
  );
}
